import { deleteCustomerFeedbackSummary, upsertCustomerFeedback, upsertCustomerFeedbackSummary } from "features/journey-map/reducer/CJMActions";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import GenericPopover from "shared/popovers/GenericPopover";
import { GenericButton } from "shared/ui-basics/buttons";
import { FlexColumnAlignCenter, Label } from "shared/ui-basics/index";
import { SmileyRating } from "shared/ui-basics/ui-components/EmotionLevelComponents/SmileyRating";
import { SmileyStaticComponent } from "shared/ui-basics/ui-components/EmotionLevelComponents/SmileyStaticComponent";
import { v4 as uuidv4 } from "uuid";
import * as Styles from "../Styles";
import { useItem } from "shared/dynamic-imports";

export const Manual = ({ feedback, stageId, isDisable }) => {
	const { t } = useTranslation();
	const innerRef = useRef(null);
	const { cjmIdStr: cjmId, personaIdStr: personaId } = useLocation()?.search.getMapsParams();
	const { customerFeedbackDatas } = feedback || {};
	const customerFeedbackId = feedback?.id;
	const [contactData, setContactData] = useState(customerFeedbackDatas || []);
	const isReadOnly = useSelector(({ auth }: any) => auth.userInfo.UserType)?.isReadOnly();
	const { handleChange ,currentItem} = useItem();

	const onChangeInput = (e, contactId) => {
		const { name, value } = e.target;

		const editData = contactData.map((item) => (item.id === contactId && name ? { ...item, [name]: value } : item));
		setContactData(editData);
	};

	const update = (e, id) => {
		let copyData;
		const { name, value } = e.target;
		// optimistic update
		const dataDB = customerFeedbackDatas.getById(id);
		const updateData = contactData.getById(id);
		if (name === "interactionDate") {
			copyData = { ...updateData, interactionDate: value };
			const editData = contactData?.map((item) => (item.id === id ? { ...item, interactionDate: value } : item));
			setContactData(editData);
		}
		if (value !== dataDB?.[name]) {
			upsertCustomerFeedbackSummary({ customerFeedbackData: copyData ?? updateData, customerFeedbackId, cjmId, stageId: stageId, personaId, touchPointId: feedback?.touchPointId });
		}
	};

	const changeEmotionLevel = (number, id) => {
		const updateData = contactData?.find((item) => item.id === id);
		const copyData = { ...updateData, sentimentIndex: number };
		upsertCustomerFeedbackSummary({ customerFeedbackData: copyData, customerFeedbackId, cjmId, stageId: stageId, personaId, touchPointId: feedback?.touchPointId });
		const editData = contactData?.map((item) => (item.id === id ? { ...item, sentimentIndex: number } : item));
		handleChange("customerFeedbackDatas",currentItem.customerFeedbackDatas.map(fd => {
			if(fd.id === copyData.id) fd = copyData
			return fd 
		}))

		setContactData(editData);
		innerRef?.current?.hide_popover();
	};

	const addContactInteractions = () => {
		const customerFeedbackData = {
			sentimentIndex: 3,
			sourcesOfData: currentItem.sourceDescription,
			description: "",
			interactionDate: new Date().toISOString(),
			numberOfInteractions: 1,
			id: uuidv4(),
		};
		setContactData((contactData) => [customerFeedbackData, ...contactData]);

		upsertCustomerFeedbackSummary({ customerFeedbackData, customerFeedbackId, cjmId, stageId, personaId, touchPointId: feedback?.touchPointId, cxMetricsId: feedback?.cxMetricsId });
		handleChange("customerFeedbackDatas",customerFeedbackDatas.length == 0 ? [customerFeedbackData] :[...customerFeedbackDatas,customerFeedbackData] )

	};

	const startCreateData = () => {
		upsertCustomerFeedback({ customerFeedback: { ...feedback, retrieveData: true }, cjmId, onSuccess: addContactInteractions });
		handleChange("retrieveData",true)
	};

	const handleDelete = (id) => {
		deleteCustomerFeedbackSummary({ customerFeedbackDataId: id, cjmId, stageId, personaId, touchPointId: feedback?.touchPointId, customerFeedbackId: feedback?.id });
		const editData = contactData?.filter((item) => item.id !== id);
		setContactData(editData);
	};
	const confirmRetrieveData = (event) => {
		confirmPopup({
			target: event.currentTarget,
			className: "w-25",
			message: t("RETRIEVE_DATA_MANUAL"),
			icon: "pi pi-info-circle",
			rejectClassName: "d-none",
			acceptClassName: "confirm-popup-button p-1",
			acceptLabel: t("START_ADDING_DATA"),
			accept: startCreateData,
		});
	};

	const Custom = ({ contact }) => {
		return (
			<div>
				<SmileyRating emotionLevel={contact?.sentimentIndex} onSelect={(number) => changeEmotionLevel(number, contact?.id)} />
			</div>
		);
	};
	return (
		<>
			{!isDisable && <div className="d-flex justify-content-start pt-4">
				<ConfirmPopup />
				<GenericButton icon="PLUS" variant="light-link" onClick={confirmRetrieveData}>
					{t("ADD_ROW")}
				</GenericButton>
			</div>}
			{feedback?.retrieveData && !isReadOnly && (
				<>
					<div className="my-3">
						<GenericButton icon="PLUS" variant="light-link" onClick={addContactInteractions}>
							{t("ADD_ROW")}
						</GenericButton>
					</div>
					<div className="">
						<Styles.TableWrapper>
							<Styles.StyledTable>
								<thead>
									<tr>
										<Styles.ThWrapper>
											<Label size={12}>{t("DATE")}</Label>
										</Styles.ThWrapper>
										<Styles.ThWrapper>
											<Label size={12}>{t("SENTIMENT_INDEX")}</Label>
										</Styles.ThWrapper>
										<Styles.ThWrapper>
											<Label size={12}>{t("ASPX_177")}</Label>
										</Styles.ThWrapper>
										<Styles.ThWrapper>
											<Label size={12}>{t("KEY_WORDS")}</Label>
										</Styles.ThWrapper>
										<Styles.ThWrapper></Styles.ThWrapper>
									</tr>
								</thead>
								<tbody>
									{contactData?.map((contact, index) => (
										<Styles.TrWrapper id={"Tr_" + contact?.id} key={contact?.id} disabled={index !== 0}>
											<Styles.TdWrapper>
												<Styles.InputWrapper
													variant="default"
													disabled={index !== 0}
													name="interactionDate"
													placeholder="date placeholder"
													value={contact?.interactionDate?.formatDate()}
													type="date"
													onChange={(e) => update(e, contact?.id)}
												/>
											</Styles.TdWrapper>

											<Styles.TdWrapper style={{ cursor: index === 0 && "pointer" }}>
												<GenericPopover custom={<Custom contact={contact} />} innerRef={innerRef} disabled={index !== 0}>
													<FlexColumnAlignCenter>
														<SmileyStaticComponent emotionLevel={contact?.sentimentIndex || 0} size={24} />
													</FlexColumnAlignCenter>
												</GenericPopover>
											</Styles.TdWrapper>
											<Styles.TdWrapper>
												<Styles.InputWrapper
													iscenter={"true"}
													name="numberOfInteractions"
													type="number"
													value={contact?.numberOfInteractions || 1}
													onChange={(e) => onChangeInput(e, contact?.id)}
													onBlur={(e) => update(e, contact?.id)}
													disabled={index !== 0}
												/>
											</Styles.TdWrapper>
											<Styles.TdWrapper>
												<Styles.InputWrapper
													name="description"
													type="text"
													value={contact?.description}
													onChange={(e) => onChangeInput(e, contact?.id)}
													onBlur={(e) => update(e, contact?.id)}
													disabled={index !== 0}
												/>
											</Styles.TdWrapper>
											<Styles.TdWrapper>
												<Styles.WrapperButton>
													<GenericButton
														className="deleteButton"
														disabled={index == 0}
														tooltip={index === 0}
														tooltipText={t("LAST_ROW")}
														variant="light-link"
														icon={"DELETE"}
														id={contact?.id}
														name={contact?.id}
														onClick={() => handleDelete(contact?.id)}
													/>
												</Styles.WrapperButton>
											</Styles.TdWrapper>
										</Styles.TrWrapper>
									))}
								</tbody>
							</Styles.StyledTable>

						</Styles.TableWrapper>
					</div>
				</>
			)}
		</>
	);
};
Manual.propTypes = {
	feedback: PropTypes.shape({
		stopRetrieveData: PropTypes.bool,
		touchPointId: PropTypes.string,
		cxMetricsId: PropTypes.string,
		retrieveData: PropTypes.bool,
		id: PropTypes.string,
	}),
	stageId: PropTypes.string,
	isViewer: PropTypes.bool,
};
